module.exports = __webpack_public_path__ + "img/img-kingmaker-d.b12be423.png";